import get from 'lodash/get';
import queryString from 'qs';
function getQueryStringValue(param, defaultValue) {
  var value;
  if (window && get(window, 'location.search')) {
    var query = queryString.parse((get(window, 'location.search') || '').replace('?', '')) || {};
    value = query[param];
  }
  return value || defaultValue;
}
export default getQueryStringValue;